const countryBasePath = 'https://api.country.is/';
const exchangeRateBasePath = 'https://aisa.sirket.im/currency/';
var currentExchange = { "USD": 99.99, "EUR": 99.99 };
var userCountry = 'US';

const configMap = [
  {
    currency:'USD', countries : ['US'], url : '/en-int',
  },
  {
    currency:'TRY', countries : ['TR'], url : '/',
  },
  {
    currency:'EUR', countries : ['GI', 'IS', 'LU', 'GB', 'GG', 'EE', 'DE', 'VA', 'BY', 'AL', 'SJ', 'UA', 'PT', 'GR', 'NO', 'AX', 'SM', 'HR', 'SI', 'BE', 'LV', 'FI', 'IT', 'MC', 'SK', 'PL', 'RU', 'FO', 'CZ', 'AD', 'AT', 'DK', 'ES', 'JE', 'SE', 'MK', 'CY', 'ME', 'IM', 'FR', 'LT', 'MD', 'RS', 'RO', 'XK', 'IE', 'BA', 'MT', 'HU', 'BG', 'NL', 'CH', 'LI'], url : '/en-eu'
  },
]

const getConfigByCountry = (countryCode) => {
  var config = configMap.find(x=>x.countries.indexOf(countryCode)>-1);
  if(isEmpty(config)){
    config = configMap[0];
  }
  return config;
}

const getUserLocation = async () => {
    try {
        const locationResponse = await fetch(countryBasePath);
        const jsonData = await locationResponse.json();
        if (jsonData.country != "TR")
        {
          var userConfig = getConfigByCountry(jsonData.country);
          if(window.location.pathname.indexOf(userConfig.url)===-1){
            var pathInfo = window.location.pathname.split('/').filter(x=> x.length>0);
            pathInfo.shift();
            var pathName = pathInfo.join('/');
            var newPath = `${userConfig.url}/${pathName}`
            window.location.href = newPath
          }
          $(".cartCurrencyNotify").show();
        }
        else {
          
          if (window.location.pathname.indexOf("/en-int")!==-1 || window.location.pathname.indexOf("/en-eu")!==-1)
          {
            var pathInfo = window.location.pathname.split('/').filter(x=> x.length>0);
            pathInfo.shift();
            var pathName = pathInfo.join('/');
            var newPath = `/${pathName}`
            window.location.href = newPath
          }
        }
        return jsonData.country;
    } catch (error) {
      console.log(error);
        return "TR";
    }
}

const getCurrentExchangeRate = async () => {
    try {
        const exchangeResponse = await fetch(exchangeRateBasePath);
        const jsonData = await exchangeResponse.json();
        return jsonData;
    } catch (error) {
        return { "USD": 99.99, "EUR": 99.99 };
    }
};

const priceToFormat = (price, currencyCode) => {
    const formatter = Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode });
    var res = formatter.format(price);
    return res;
}

const updatePrice = async (exchangeRate, type) => {
    document.querySelectorAll('.price-item, .price__badge--sale').forEach((item, index) => {
        $(item).show();
        $(".cartCurrencyNotify").show();
        if(!item.hasAttribute('data-currency-original')){
            item.setAttribute('data-currency-original',item.innerHTML.replace('save ',''));
            var priceStr = item.innerHTML.replace(/[^\d.]/g, '');
            try {
                var price = parseFloat(priceStr);
                convertedPrice = Math.round(price / exchangeRate);
                var viewPrice = priceToFormat(convertedPrice, type);
                item.innerHTML = viewPrice;
            } catch (error) {
                //console.log('price converter error',error)
            }
        }
    });
}

const updatePrice2 = async (item, exchangeRate, type) => {
      $(item).show();
      if(!item.hasAttribute('data-currency-original')){
          item.setAttribute('data-currency-original',item.innerHTML);
          var priceStr = item.innerHTML;
          priceStr = priceStr.replace('TR', '').replace(',', '');
          try {
              var price = parseFloat(priceStr);
              convertedPrice = Math.round(price / exchangeRate);
              var viewPrice = priceToFormat(convertedPrice, type);
              console.log(price,convertedPrice,viewPrice);
              item.innerHTML = viewPrice;
          } catch (error) {
              //console.log('price converter error',error)
          }
      }
}

window.addEventListener("DOMContentLoaded", async (event) => {
    userCountry = await getUserLocation();
    currentExchange = await getCurrentExchangeRate();
    if (userCountry !== 'TR') {
        var userConfig = getConfigByCountry(userCountry);
        updatePrice(userConfig.currency === 'USD' ? currentExchange.USD : currentExchange.EUR, userConfig.currency);
        $(".cartCurrencyNotify").show();
    }else{
      $(".price-item").show();
    }
    const config = { childList: true, subtree: true };
    observer.observe(document.getElementsByTagName('body')[0], config);

  $('#formVariantId').change(function(changes, observer){
      console.log(userCountry)
    if (userCountry !== 'TR') {
      console.log("DENEME");
      var newVariantId = parseInt($(this).val());
      $("#product-price").find('.price-item').each(function(item,index){
        console.log(item);
        var originalPrice = meta.product.variants.filter(x=>x.id==newVariantId);
        $(this).removeAttr('data-currency-original');
        $(this).text((originalPrice[0].price/100).toFixed(2));
      });
      
      var userConfig = getConfigByCountry(userCountry);
      updatePrice(userConfig.currency === 'USD' ? currentExchange.USD : currentExchange.EUR, userConfig.currency);
      $(".cartCurrencyNotify").show();
    }else{
      $(".price-item").show();
    }
  });
});




const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    const addedNodes = Array.from(mutation.addedNodes);
    const newElements = addedNodes.filter(function(node) {
      return node.nodeType === Node.ELEMENT_NODE;
    });
    console.log(newElements)
    if(newElements.length>0){
      $('input[name="id"]').change(function(changes, observer){
        if (userCountry !== 'TR') {
      console.log("DENEME");
          var newVariantId = parseInt($(this).val());
          var productData = JSON.parse($("script.product-json").text());
          $("#product-price").find('.price-item, .price__badge--sale').each(function(item,index){
            var originalPrice = productData.variants.filter(x=>x.id==newVariantId);
            $(this).removeAttr('data-currency-original');
            $(this).text((originalPrice[0].price/100).toFixed(2));
          });
          
          var userConfig = getConfigByCountry(userCountry);
          updatePrice(userConfig.currency === 'USD' ? currentExchange.USD : currentExchange.EUR, userConfig.currency);
        }else{
          $(".price-item").show();
        }
      });
      if (userCountry !== 'TR') {
        var userConfig = getConfigByCountry(userCountry);
        updatePrice(userConfig.currency === 'USD' ? currentExchange.USD : currentExchange.EUR, userConfig.currency);
      }else{
        $(".price-item").show();
      }
    }
  });
});


function isEmpty(value) {
  return (value == null || (typeof value === "string" && value.trim().length === 0));
}